import { Box, Theme, useMediaQuery } from "@mui/material";
import React from "react";
import { ShowHistoric } from "@features/depots/components/DepotsDashboard/ShowHistoric";
import { ExportButton } from "@features/depots/components/DepotsDashboard/ExportButton";

type Props = {
  onShowHistoricChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  activeTab?: string;
  accountIds: number[];
  minDate: string;
  maxDate: string;
  showHistoric: boolean;
  inTabsBar?: boolean;
};

export const InvestmentActions = ({
  activeTab,
  showHistoric,
  minDate,
  maxDate,
  onShowHistoricChange,
  accountIds,
  inTabsBar = true,
}: Props) => {
  const isLessMd = useMediaQuery((t: Theme) => t.breakpoints.down("md"));
  const isLessSm = useMediaQuery((t: Theme) => t.breakpoints.down("sm"));

  const showCheckbox = inTabsBar
    ? !isLessMd && activeTab === "investments"
    : isLessMd;
  const showExport = inTabsBar ? !isLessSm : isLessSm;

  if (!showCheckbox && !showExport) return null;

  const exportParams = {
    accountId: accountIds,
    includeHistoric: showHistoric,
    minDate,
    maxDate,
  };

  if (inTabsBar) {
    return (
      <Box display="flex" alignItems="center">
        {showCheckbox && (
          <ShowHistoric
            checked={showHistoric}
            onChange={onShowHistoricChange}
          />
        )}
        {showExport && (
          <ExportButton activeTab={activeTab} params={exportParams} />
        )}
      </Box>
    );
  }

  return (
    <>
      {showCheckbox && (
        <Box mt={4} ml={3} mb={4}>
          <ShowHistoric
            checked={showHistoric}
            onChange={onShowHistoricChange}
          />
        </Box>
      )}
      {showExport && (
        <Box mt={4}>
          <ExportButton activeTab={activeTab} fullWidth params={exportParams} />
        </Box>
      )}
    </>
  );
};
